import data from "country-region-data/data.json";

type DataRegionItem = {
  name: string;
  shortCode?: string;
};

type DataItem = {
  countryName: string;
  countryShortCode: string;
  regions: DataRegionItem[];
};

export type RegionItem = {
  id: number;
  name: string;
  shortCode?: string;
};

export type CountryItem = {
  id: number;
  name: string;
  countryShortCode: string;
  regions: RegionItem[];
};

/**
 * Gets list of CountryItems sorted by popularity
 * @returns array of CountryItem objects
 */
const getCountries = (): CountryItem[] => {
  const popularCountries: CountryItem[] = [];
  const otherCountries: CountryItem[] = [];

  data.forEach((c: DataItem, cIndex) => {
    const newCountryItem: CountryItem = {
      id: cIndex,
      name: c.countryName,
      countryShortCode: c.countryShortCode,
      regions: c.regions.map((region, rIndex) => {
        return {
          id: rIndex,
          ...region,
        };
      }),
    };

    if (
      c.countryShortCode === "AU" ||
      c.countryShortCode === "CA" ||
      c.countryShortCode === "GB" ||
      c.countryShortCode === "US"
    ) {
      popularCountries.push(newCountryItem);
      return;
    }

    otherCountries.push(newCountryItem);
  });

  return popularCountries.concat(otherCountries);
};

export const countries: CountryItem[] = getCountries();
export const countriesNameMap = new Map(countries.map((c) => [c.name, c]));

export const getCountryByName = (name: string): CountryItem | undefined => {
  return countriesNameMap.get(name);
};

/**
 * Gets a list of regions associated with an input country
 * @param country the name of a country to match on
 * @returns array of RegionItem objects that include the region name and shortCode
 */
export const getRegions = (country: string): RegionItem[] | undefined => {
  return countries.find((c) => c.name === country)?.regions;
};
